export const assetUrl = (url: string): string => {
  // If the url is relative and we hae an assests domain defined, then we will
  // load the resource from the assets domain.
  if (url.startsWith('/') && process.env.GATSBY_ASSETS_DOMAIN) {
    return `${process.env.GATSBY_ASSETS_DOMAIN}${url}`
  }
  return url;
}
